import styled from 'styled-components'

import CircleInfo from '~/features/circle-participation/components/CircleInfo'
import EventInfo from '~/features/circle-participation/components/EventInfo'
import theme from '~/shared/styles/theme'

function CircleApplyDetailPage() {
  return (
    <Wrapper>
      <Title>서클 부스 신청 상세</Title>
      <EventInfo />
      <CircleInfo />
    </Wrapper>
  )
}

export default CircleApplyDetailPage

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
  align-items: flex-start;

  box-sizing: border-box;
  width: 100%;
  max-width: 1080px;
  min-height: calc(100vh - ${theme.size.headerHeight}px);
  margin: 0 auto;
  margin-top: calc(80px + ${theme.size.headerHeight}px);
  margin-bottom: 120px;

  @media ${theme.device.large} {
    width: 100%;
    padding: 20px 26px;
  }

  @media ${theme.device.medium} {
    gap: 24px;
    align-items: start;

    width: 100%;
    margin-top: calc(56px + ${theme.size.headerHeight}px);
    padding: 20px 26px;
  }
`

const Title = styled.h1`
  ${theme.fontStyle.title};
  text-align: left;
  white-space: pre-line;

  @media ${theme.device.medium} {
    ${theme.fontStyle.titleMobile};
    width: 100%;
    height: auto;
  }
`
